import { render } from "./ItemChecklistComponent.vue?vue&type=template&id=a6c876dc&ts=true"
import script from "./ItemChecklistComponent.vue?vue&type=script&lang=ts"
export * from "./ItemChecklistComponent.vue?vue&type=script&lang=ts"

import "./ItemChecklistComponent.vue?vue&type=style&index=0&id=a6c876dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__